import type { Aba } from '@shared/components/Abas';
import { Resumo } from '@curso/sections/Resumo';
import { ProvaImediata } from '@curso/sections/ProvaImediata';
import { Investimento } from '@curso/sections/Investimento';
import { Incluso } from '@curso/sections/Incluso';
import { OProblema } from '@curso/sections/OProblema';
import { DeOndeVem } from '@curso/sections/DeOndeVem';
import { OndeChegamos } from '@curso/sections/OndeChegamos';
import { ComoFunciona } from '@curso/sections/ComoFunciona';
import { OQueVoceLeva } from '@curso/sections/OQueVoceLeva';
import { FimDeSemana } from '@curso/sections/FimDeSemana';
import { NaSuaUnidade } from '@curso/sections/NaSuaUnidade';
import { QuemEnsina } from '@curso/sections/QuemEnsina';
import { QuemOrganiza } from '@curso/sections/QuemOrganiza';
import { Duvidas } from '@curso/sections/Duvidas';

/**
 * O agrupamento dos blocos em abas.
 *
 * Este arquivo é o único lugar onde a divisão existe. Mover um bloco de aba,
 * renomear uma aba ou trocar a ordem é editar daqui, sem tocar em bloco nenhum.
 *
 * Cada aba cabe em pouco mais de uma tela. Aba que exige rolagem longa deixa
 * de ser aba e vira de novo a página corrida que a gente estava evitando.
 *
 * "Na sua unidade" é a camada de implantação, e é a aba que fala com quem
 * coordena. Sem ela a página vendia ferramenta sem dizer como fazer pegar.
 */
export const ABAS: Aba[] = [
  {
    id: 'resumo',
    rotulo: 'Resumo',
    conteudo: (
      <>
        <Resumo />
        <ProvaImediata />
      </>
    ),
  },
  {
    id: 'por-que',
    rotulo: 'Por que existe',
    conteudo: (
      <>
        <OProblema />
        <OndeChegamos />
      </>
    ),
  },
  {
    id: 'de-onde-vem',
    rotulo: 'De onde vem',
    conteudo: <DeOndeVem />,
  },
  {
    id: 'como-funciona',
    rotulo: 'Como funciona',
    conteudo: <ComoFunciona />,
  },
  {
    id: 'ferramentas',
    rotulo: 'Ferramentas',
    conteudo: <OQueVoceLeva />,
  },
  {
    id: 'fim-de-semana',
    rotulo: 'Fim de semana',
    conteudo: <FimDeSemana />,
  },
  {
    id: 'na-sua-unidade',
    rotulo: 'Na sua unidade',
    conteudo: <NaSuaUnidade />,
  },
  {
    id: 'quem-facilita',
    rotulo: 'Quem facilita',
    conteudo: (
      <>
        <QuemEnsina />
        <QuemOrganiza />
      </>
    ),
  },
  {
    id: 'investimento',
    rotulo: 'Investimento',
    conteudo: (
      <>
        <Investimento />
        <Incluso />
      </>
    ),
  },
  {
    id: 'duvidas',
    rotulo: 'Dúvidas',
    conteudo: <Duvidas />,
  },
];

export const ABA_PADRAO = 'resumo';
